<div class="section">
	<particles></particles>
	<div class="row align-items-center minContentHeight text-center">
		<div class="col-sm-6 container">
			<h5 i18n="Modal Titel for SubscriptionConfirmation@@subcription-confirmed.title">Pre-Registration Confirmed!</h5>
			<div class="innerContainer">
				Thank you for your interest in <span class="gameName">Arkheim - Realms at war!</span><br/>
				<br/>
				We will contact you as soon the closed beta will start!<br/>
				<br/>
				<div>
					<button type="button" class="btn btn-primary" routerLink="/">
						<span i18n="@@title">Continue!</span>
					</button>
				</div>
			</div>
		</div>
	</div>
</div>